// extracted by mini-css-extract-plugin
export var change = "_3g-1";
export var changeList = "_3g-0";
export var changePath = "_3g-2";
export var diffArrow = "_3g-5";
export var diffRow = "_3g-3";
export var diffValue = "_3g-4";
export var error = "_3g-8";
export var notice = "_3g-9";
export var result = "_3g-6";
export var success = "_3g-7";